import { createRouter, createWebHistory } from 'vue-router';
import store from './store';
import { hasPermission, firstAllowedRoute } from './service/permissions';
import { bootReady } from './service/bootGate';

const routes = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('./App.vue'),
        children: [
            {
                path: '',
                name: 'dashboard-panel',
                meta: { permission: 'dashboard' },
                component: () => import('./components/Dashboard.vue')
            },
            {
                path: 'general/informacion-basica',
                name: 'informacion-basica',
                meta: { permission: 'business' },
                component: () => import('./components/Business/BusinessCRUD.vue')
            },
            {
                path: 'general/suscripcion',
                name: 'suscripcion',
                meta: { permission: 'subscription' },
                component: () => import('./components/Subscription/Subscriptions.vue')
            },
            {
                path: 'general/configuracion',
                name: 'configuracion',
                meta: { permission: 'configuration' },
                component: () => import('./components/Business/Configurations.vue')
            },
            {
                path: 'general/usuarios',
                name: 'subUsers',
                meta: { permission: 'configuration' },
                component: () => import('./components/Business/SubUsers.vue')
            },
            {
                path: 'general/horarios',
                name: 'horarios',
                meta: { permission: 'workSchedule' },
                component: () => import('./components/Business/WorkSchedules.vue')
            },
            {
                path: 'documentos/firmar-pdf',
                name: 'firmarPdf',
                meta: { permission: 'documentSign' },
                component: () => import('./components/Documents/PdfSigner.vue')
            },
            {
                path: 'cliente/crud',
                name: 'customerCRUD',
                meta: { permission: 'customers' },
                component: () => import('./components/Customer/customerCRUD.vue')
            },
            {
                path: 'producto/crud',
                name: 'productCRUD',
                meta: { permission: 'products' },
                component: () => import('./components/Product/productCRUD.vue')
            },
            {
                path: 'producto/kardex',
                name: 'productKardex',
                meta: { permission: 'productsManage' },
                component: () => import('./components/Product/productKardex.vue')
            },
            {
                path: 'inventario/conteo',
                name: 'inventoryCountWizard',
                meta: { permission: 'inventoryCount' },
                component: () => import('./components/Product/Inventory/InventoryCountWizard.vue')
            },
            {
                path: 'inventario/conteo/historial',
                name: 'inventoryCountList',
                meta: { permission: 'inventoryManage' },
                component: () => import('./components/Product/Inventory/InventoryCountList.vue')
            },
            {
                path: 'inventario/conteo/detalle',
                name: 'inventoryCountDetail',
                meta: { permission: 'inventoryManage' },
                component: () => import('./components/Product/Inventory/InventoryCountDetail.vue')
            },
            {
                path: 'inventario/sincronizar',
                name: 'stockSync',
                meta: { permission: 'stockSync' },
                component: () => import('./components/Product/Inventory/StockSync.vue')
            },
            {
                path: 'inventario/ajustes',
                name: 'stockAdjustmentLog',
                meta: { permission: 'inventoryManage' },
                component: () => import('./components/Product/Inventory/StockAdjustmentLog.vue')
            },
            {
                // Se abre desde «Ajustes de inventario»: sin ítem de menú propio.
                path: 'inventario/lista-compras',
                name: 'shoppingList',
                meta: { permission: 'inventoryManage' },
                component: () => import('./components/Product/Inventory/ShoppingList.vue')
            },
            {
                path: 'proveedor/crud',
                name: 'providerCRUD',
                meta: { permission: 'providers' },
                component: () => import('./components/Provider/providerCRUD.vue')
            },
            {
                path: 'balance-saldo',
                name: 'Balance',
                meta: { permission: 'balance' },
                component: () => import('./components/Balance/Balance.vue')
            },
            {
                path: 'cuenta/crud',
                name: 'finantialAccountCRUD',
                meta: { permission: 'finantialAccounts' },
                component: () => import('./components/Accounting/FinantialAccountCRUD.vue')
            },
            {
                path: 'cuenta/detalle',
                name: 'finantialAccountTransaction',
                meta: { permission: 'finantialAccounts' },
                component: () => import('./components/Accounting/FinantialAccountTransaction.vue')
            },
            {
                path: 'cuentas-por-cobrar-pagar',
                name: 'accountsReceivablePayable',
                meta: { permission: 'receivablesPayables' },
                component: () => import('./components/Accounting/AccountsReceivablePayable.vue')
            },
            {
                path: 'cierre-caja',
                name: 'cashClosingWizard',
                meta: { permission: 'cashClosing' },
                component: () => import('./components/Accounting/CashClosing/CashClosingWizard.vue')
            },
            {
                path: 'cierre-caja/historial',
                name: 'cashClosingList',
                meta: { permission: 'cashClosingManage' },
                component: () => import('./components/Accounting/CashClosing/CashClosingList.vue')
            },
            {
                path: 'cierre-caja/detalle',
                name: 'cashClosingDetail',
                meta: { permission: 'cashClosingManage' },
                component: () => import('./components/Accounting/CashClosing/CashClosingDetail.vue')
            },
            {
                path: 'contabilidad/apertura',
                name: 'contabilidadApertura',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/AperturaContable.vue')
            },
            {
                path: 'contabilidad/estado-resultados',
                name: 'contabilidadEstadoResultados',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/EstadoResultados.vue')
            },
            {
                path: 'contabilidad/balance-general',
                name: 'contabilidadBalanceGeneral',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/BalanceGeneral.vue')
            },
            {
                path: 'contabilidad/balance-comprobacion',
                name: 'contabilidadBalanceComprobacion',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/BalanceComprobacion.vue')
            },
            {
                path: 'contabilidad/plan-cuentas',
                name: 'contabilidadPlanCuentas',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/PlanCuentas.vue')
            },
            {
                path: 'contabilidad/mapeos',
                name: 'contabilidadMapeos',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/Mapeos.vue')
            },
            {
                path: 'contabilidad/activos',
                name: 'contabilidadActivosFijos',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/ActivosFijos.vue')
            },
            {
                path: 'contabilidad/liquidaciones',
                name: 'contabilidadLiquidaciones',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/Liquidaciones.vue')
            },
            {
                path: 'contabilidad/resumen-iva',
                name: 'contabilidadResumenIVA',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/ResumenIVA.vue')
            },
            {
                path: 'contabilidad/conciliacion',
                name: 'contabilidadConciliacion',
                meta: { permission: 'accounting' },
                component: () => import('./components/Accounting/Contabilidad/ConciliacionPasarelas.vue')
            },
            {
                path: 'proforma/crud',
                name: 'proformaCRUD',
                meta: { permission: 'proformas' },
                component: () => import('./components/Proforma/proformaCRUD.vue')
            },
            {
                path: 'proforma/form',
                name: 'proformaForm',
                meta: { permission: 'proformas' },
                component: () => import('./components/Proforma/proformaForm.vue')
            },
            {
                path: 'venta/crud',
                name: 'saleCRUD',
                meta: { permission: 'sales' },
                component: () => import('./components/Sale/saleCRUD.vue')
            },
            {
                // Ruta vieja: el listado de ventas del restaurante, cuando su "Ventas" era el salón.
                path: 'venta/historial',
                redirect: '/dashboard/venta/crud'
            },
            {
                path: 'venta/form',
                name: 'saleForm',
                meta: { permission: 'sales' },
                component: () => import('./components/Sale/saleForm.vue')
            },
            {
                // El Salón (giro restaurante): las ventas abiertas por mesa y zona, aparte de Ventas.
                path: 'salon',
                name: 'salon',
                meta: { permission: 'restaurantTables' },
                component: () => import('./components/Restaurant/SalonEntry.vue')
            },
            {
                // Ruta vieja de las mesas (R2).
                path: 'restaurante/mesas',
                redirect: '/dashboard/salon'
            },
            {
                path: 'compra/crud',
                name: 'purchaseCRUD',
                meta: { permission: 'purchases' },
                component: () => import('./components/Purchase/purchaseCRUD.vue')
            },
            {
                path: 'compra/form',
                name: 'purchaseForm',
                meta: { permission: 'purchases' },
                component: () => import('./components/Purchase/purchaseForm.vue')
            },
            {
                path: 'guia-remision/crud',
                name: 'remisionGuideCRUD',
                meta: { permission: 'remisionGuides' },
                component: () => import('./components/RemisionGuide/remisionGuideCRUD.vue')
            },
            {
                path: 'guia-remision/form',
                name: 'remisionGuideForm',
                meta: { permission: 'remisionGuides' },
                component: () => import('./components/RemisionGuide/remisionGuideForm.vue')
            },
            {
                path: 'nota-credito/crud',
                name: 'creditNoteCRUD',
                meta: { permission: 'creditNotes' },
                component: () => import('./components/CreditNote/creditNoteCRUD.vue')
            },
            {
                path: 'nota-credito/form',
                name: 'creditNoteForm',
                meta: { permission: 'creditNotes' },
                component: () => import('./components/CreditNote/creditNoteForm.vue')
            },
        ]
    },
    {
        // La raíz la resuelve el guard de abajo (redirige a firstAllowedRoute si hay sesión, o al
        // sitio de marketing si no). Se declara como ruta para que el matcher NO emita
        // "No match found for location with path '/'" en la llegada inicial (p.ej. desde el registro).
        path: '/',
        name: 'root',
        component: () => import('./pages/LandingDemo.vue')
    },
    {
        path: '/inicio',
        name: 'landing',
        component: () => import('./pages/LandingDemo.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/olvido-contrasena',
        name: 'forgot-password',
        component: () => import('./pages/ForgotPassword.vue')
    },
    {
        path: '/recuperar-contrasena',
        name: 'reset-password',
        component: () => import('./pages/ResetPassword.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Compuerta de arranque: espera a que boot() (main.js) rehidrate la sesión desde la cookie ANTES
// de evaluar cualquier guard de autenticación. Evita la carrera en la que la navegación inicial
// corre con el store vacío (primera visita al llegar del registro) y manda al login por error.
router.beforeEach(async function(to, from, next) {
    await bootReady;
    next();
});

router.beforeEach(function(to, from, next) {
    // Raíz o la vieja landing demo (/inicio, name "landing"): autenticado -> su primer destino
    // permitido; NO autenticado -> login. El dashboard vive en app.contablus.com y el sitio de
    // marketing (contablusWeb) en la raíz del dominio, que ya lleva al panel a quien tiene sesión:
    // devolver al sitio a quien llega aquí sin sesión podría rebotar en bucle. Ya no se renderiza
    // LandingDemo.vue (obsoleta; ver docs/tech-debt-and-production-migration.md en el backend).
    if (to.fullPath === "/" || to.name === "landing") {
        if (store.getters.isAuthenticated) {
            next(firstAllowedRoute());
        } else {
            next({name: "login"});
        }
    } else { next(); }
});

router.beforeEach(function(to, from, next) {
    if (to.fullPath.startsWith('/login')) {
        if (store.getters.isAuthenticated) {
            next(firstAllowedRoute());
        } else { next(); }
    } else { next(); }
});

router.beforeEach(function(to, from, next) {
    if (to.fullPath.startsWith('/dashboard')) {
        if (!store.getters.isAuthenticated) {
            next({name: "login"});
        } else { next(); }
    } else { next(); }
});

// Guard de autorización por permiso (capa UX; la seguridad real es el decorador en backend).
// Redirige al usuario fuera de una ruta cuyo permiso no tiene, hacia su primera ruta permitida.
router.beforeEach(function(to, from, next) {
    if (!to.fullPath.startsWith('/dashboard')) return next();
    const code = to.meta && to.meta.permission;
    if (!code) return next();
    if (!store.getters.isAuthenticated) return next({name: "login"});
    if (hasPermission(code)) return next();
    const landing = firstAllowedRoute();
    if (to.path === landing) return next(); // evitar loop si su propio landing estuviera restringido
    return next(landing);
});

export default router;
